module.exports = __webpack_public_path__ + "img/notifications_on.c9095a64.svg";